module.exports = __webpack_public_path__ + "static/img/picture7.9c4b5ace.png";